import { DialogContent, Stack } from "@mui/material";
import { openZendeskMessaging } from "@src/appV2/lib/ZendeskMessaging/openZendeskMessaging";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { BottomSheet, Text, type UseModalState } from "@src/appV2/redesign/system/ui-components";
import { generatePath, useHistory } from "react-router-dom";

import { DOCUMENT_STRIPE_VERIFICATION_SELECT_SUBTYPE_FULL_PATH } from "../../../paths";
import { DocumentSubmissionRejectedBottomSheetContent } from "../../../Submission/RejectedContent";
import { useRequirementDetailsContext } from "../../useRequirementDetailsContext";

interface DocumentDetailsStripeIdentityVerificationRejectedBottomSheetProps {
  modalState: UseModalState;
}

export function DocumentDetailsStripeIdentityVerificationRejectedBottomSheet(
  props: DocumentDetailsStripeIdentityVerificationRejectedBottomSheetProps
) {
  const { requirement } = useRequirementDetailsContext();
  const { documents } = requirement;
  const document = documents?.[0];
  const { requirementId } = requirement;
  const history = useHistory();

  const { modalState } = props;

  return (
    <BottomSheet
      canDismiss
      modalState={modalState}
      footer={
        <DialogFooter
          orientation="vertical"
          onClose={() => {
            modalState.closeModal();
          }}
        >
          <Stack spacing={5} sx={{ width: "100%" }}>
            <Button
              size="large"
              onClick={() => {
                history.replace(
                  generatePath(`${DOCUMENT_STRIPE_VERIFICATION_SELECT_SUBTYPE_FULL_PATH}`, {
                    requirementId,
                  })
                );
              }}
            >
              Try again
            </Button>
            <Button
              variant="outlined"
              size="large"
              onClick={() => {
                void openZendeskMessaging();
              }}
            >
              Reach out to support
            </Button>
          </Stack>
        </DialogFooter>
      }
    >
      <DialogContent sx={{ paddingX: 5, paddingBottom: 0 }}>
        <DocumentSubmissionRejectedBottomSheetContent
          title="Please try again"
          description={
            <Stack spacing={8}>
              <Text variant="h6">
                {document?.attributes?.notification?.note ??
                  document?.attributes?.notification?.reason}
              </Text>
            </Stack>
          }
        />
      </DialogContent>
    </BottomSheet>
  );
}
